import { Constants } from "@constants";

const getCookie = (cname) => {
  const name = `${cname}=`;
  const cookieList = document.cookie.split(";");
  for (let i = 0; i < cookieList.length; i++) {
    const cookieItem = cookieList[i]?.trim();
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.split("=")[1];
    }
  }
  return "";
};

const deleteCookie = (name) => {
  document.cookie =
    name +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.gartner.com; path=/; ";
};

export const getAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(Constants.ROUTES.APP_LOCAL_PATH) !== -1 ||
  Constants.ROUTES.APP_DEMO_PATH.indexOf(domain) !== -1) {
    return getCookie(name);
  }
  return localStorage.getItem(name);
};

export const deleteAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(Constants.ROUTES.APP_LOCAL_PATH) !== -1 ||
  Constants.ROUTES.APP_DEMO_PATH.indexOf(domain) !== -1) {
    return deleteCookie(name);
  }
  return localStorage.removeItem(name);
};
